// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, schema de busca, catálogo e os carregadores
// das telas. Outro módulo usa a `public.ts` (A06).
export {
  HIRE_PATH,
  PERSONAL_CREDIT_PATH,
  SIMULATE_PATH,
  simulationHireScreen,
  simulationPersonalCreditScreen,
  simulationSimulateScreen,
  VEHICLE_PATH,
} from './simulation.screen';
export {
  CAR_EQUITY_PATH,
  simulationCarEquityScreen,
  simulationVehicleFinancingScreen,
  simulationVehicleScreen,
  VEHICLE_FINANCING_PATH,
} from './simulation-vehicle.screen';
export {
  PUBLIC_PAYROLL_NEW_PATH,
  PUBLIC_PAYROLL_PATH,
  simulationPublicPayrollNewScreen,
  simulationPublicPayrollScreen,
} from './simulation-payroll.screen';
export {
  INSS_PAYROLL_NEW_PATH,
  INSS_PAYROLL_PATH,
  PRIVATE_CDC_PAYROLL_PATH,
  PRIVATE_PAYROLL_NEW_PATH,
  PRIVATE_PAYROLL_PATH,
  simulationInssPayrollNewScreen,
  simulationInssPayrollScreen,
  simulationPrivateCdcPayrollScreen,
  simulationPrivatePayrollNewScreen,
  simulationPrivatePayrollScreen,
} from './simulation-offers.screen';
export { personalCreditSearch, simulationSearch } from './simulation.search';
export { HireLayoutRouteScreen } from './simulation-hire.layout';
export { loadSimulationMessages } from './simulation.catalog';

/** As telas de Simular e Crédito pessoal (`SimulateRouteScreen`, `PersonalCreditRouteScreen`), por `lazyScreen`. */
export const loadSimulationScreens = () => import('./simulation.page');

/** A tela de Contratar (`HireRouteScreen`), por `lazyScreen`. */
export const loadSimulationHireScreen = () => import('./simulation-hire.page');

/** O hub de Veículo (`VehicleHubRouteScreen`), por `lazyScreen`. */
export const loadSimulationVehicleHubScreen = () => import('./simulation-vehicle-hub.page');

/** Car Equity e Financiamento (`CarEquityRouteScreen`, `VehicleFinancingRouteScreen`), por `lazyScreen`. */
export const loadSimulationVehicleScreens = () => import('./simulation-vehicle.page');

/** O hub do consignado público (`PublicPayrollHubRouteScreen`), por `lazyScreen`. */
export const loadSimulationPayrollHubScreen = () => import('./simulation-payroll-hub.page');

/** O consignado público novo (`PublicPayrollRouteScreen`), por `lazyScreen`. */
export const loadSimulationPayrollScreens = () => import('./simulation-payroll.page');

/** Os hubs do INSS e do privado (`InssPayrollHubRouteScreen`, `PrivatePayrollHubRouteScreen`), por `lazyScreen`. */
export const loadSimulationOffersHubScreens = () => import('./simulation-offers-hub.page');

/** INSS, privado e privado CDC (`InssPayrollRouteScreen`, `PrivatePayrollRouteScreen`, `PrivateCdcPayrollRouteScreen`). */
export const loadSimulationOffersScreens = () => import('./simulation-offers.page');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadSimulationGuides = () => import('./simulation.guide');

export { simulationPublicRefinancingScreen, simulationPrivateRefinancingScreen, simulationInssRefinancingScreen, simulationDebtPurchaseScreen } from './simulation-renewal.screen';
export const loadSimulationRenewalScreens = () => import('./simulation-renewal.page');
